import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { EmitterService } from '../../../../shared/services/emitter.service';
import { ReportService } from '../../../../services/reportAlert/report.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AppConstants } from '../../../../shared/constants/app.contants';
import { CameraService } from '../../../../services/camera/camera.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MessageSeverity, AlertService } from 'src/app/shared/services/alert.service';
import * as FileSaver from 'file-saver';
import { PanelCameraModalComponent } from 'src/app/shared/components/modals/panel/camera/panel-camera-modal.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';
import {DateAdapter, MAT_DATE_FORMATS} from '@angular/material';
import { APP_DATE_FORMATS, AppDateAdapter } from 'src/app/shared/helpers/format-datepicker';
import { LOCALE_ID } from '@angular/core';
import { ZoneService } from 'src/app/services/zone/zone.service';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { ImageModalComponent } from 'src/app/shared/components/modals/image/image-modal.component';
import { ReportCameraCounterModel } from 'src/app/models/camera/reportCameraCounter';

@Component({
  selector: 'app-camera-counter-report',
  templateUrl: './camera-counter-report.component.html',
  styleUrls: ['./camera-counter-report.component.css']
})
export class CameraCounterReportComponent implements OnInit {
  listCameras = [];
  listCameraRegions = [];
  loading: boolean = false;
  dataSource = new MatTableDataSource<ReportCameraCounterModel>();
  displayedColumns: string[] = ['index','camera', 'region', 'state', 'shift', 'item', 'userQty', 'startedAt', 'finishedAt', 'timer', 'count',  'action'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('paginatorTop', { static: false }) paginatorTop: MatPaginator;
  @ViewChild('paginatorBottom', { static: false }) paginatorBottom: MatPaginator;
  subscription: Subscription;
  alertError = 0;

  cameras = [];
  users = [];
  cameraAlert = [];
  stats = [
    {
      id: 1, name: 'Pendiente'
    },
    {
      id: 2, name: 'En Proceso'
    },
    {
      id: 3, name: 'Atendido'
    }
  ];
  enterprises = [];
  enterpriseSelect: number;
  alertSelect: number = 0;
  cameraSelect: number = 0;
  regionSelect: number = 0;
  userSelect: number = 0;
  statuselect: number = 0;

  pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = 0;
  length: number = 0;

  reportForm: FormGroup;

  myDate = new Date();
  zoneId: number = 0;
  date = new Date();
  dateF = new Date();
  timeI: string;
  timeF: string;
  dateV:string;
  isAdministrator=false;
  dateIView:string;
  dateFView:string;
  headquarterSelect = 0;
  enterprisesZones = [];
  enterpriseZoneSelect: number = 0;
  color1: string;
  color2: string;
  colorFont: string;
  colorFont2: string;
  enabledRead: number;
  enabledWrite: number;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private spinner: NgxSpinnerService,
    private ReportService: ReportService,
    private userService: UserService,
    private enterpriseService: EnterpriseService,
    private CameraService: CameraService,
    private datePipe: DatePipe,
    private AlertService: AlertService,
    private zoneService: ZoneService,
    private formBuilder: FormBuilder,) {
      document.getElementById("titleHeaderNav").innerHTML = 'Video Analítica > <span class="font-weight-bold">Reporte de Cámaras de Conteo</span>';
    }

  ngOnInit() {
    this.setLS();
    this.createForm();
    this.enterpriseSelect = (+localStorage.getItem(AppConstants.Session.ENTERPRISE));
    this.headquarterSelect = (+localStorage.getItem(AppConstants.Session.HEADQUARTER));
    //this.getZonesByEnterprise();
    //this.userList();
    this.getListCameras();
    this.dataSource.paginator = this.paginator;
    this.timeI = this.datePipe.transform("Tue Aug 18 2020 00:00:58 GMT-0500", 'HH:mm');
    this.timeF = this.datePipe.transform("Tue Aug 18 2020 23:59:58 GMT-0500", 'HH:mm');
    this.dateV = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.setData();
    /*var arr = Array<ReportViewModel>();
    var item =new ReportViewModel();
    item.camera = "CLARIANT 05 - Secador";
    item.typeAlert = "Región 1";
    item.insertDateOcurrence = "12/01/2024 10:10:00";
    item.userName = "12/01/2024 10:30:00";
    item.enabled = "00:20:00";
    item.userUpdate = "50";
    arr.push(item);
    var item =new ReportViewModel();
    item.camera = "CLARIANT 05 - Secador";
    item.typeAlert = "Región 1";
    item.insertDateOcurrence = "12/01/2024 12:43:00";
    item.userName = "12/01/2024 12:30:00";
    item.enabled = "00:07:00";
    item.userUpdate = "10";
    arr.push(item);
    var item =new ReportViewModel();
    item.camera = "CLARIANT 05 - Secador";
    item.typeAlert = "Región 1";
    item.insertDateOcurrence = "12/01/2024 08:15:00";
    item.userName = "12/01/2024 08:25:00";
    item.enabled = "00:10:00";
    item.userUpdate = "13";
    arr.push(item);
    var item =new ReportViewModel();
    item.camera = "CLARIANT 05 - Secador";
    item.typeAlert = "Región 1";
    item.insertDateOcurrence = "12/01/2024 06:15:00";
    item.userName = "12/01/2024 06:30:00";
    item.enabled = "00:20:00";
    item.userUpdate = "10";
    arr.push(item);
    this.dataSource.data = arr;*/
  }

    getListCameras(){
    this.spinner.show();
    this.CameraService.getListCameraCounters(this.enterpriseSelect,this.headquarterSelect).subscribe((response => {
      this.listCameras = response.data;
      if(this.listCameras.length > 0){
        this.cameraSelect = this.listCameras[0].id;
       // this.enterpriseSelect = this.listCameras[0].idEnterprise;
        var d = {
          value:  this.cameraSelect
        }
        this.getListCameraRegions(d);
      }
      this.spinner.hide();
    }),
    (error: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getListCameraRegions(data){
    this.spinner.show();
    this.CameraService.getListRegionsCameraCounter(data.value).subscribe((response => {
      this.listCameraRegions = response.data;
      if(this.listCameraRegions.length == 1){
        this.regionSelect = this.listCameraRegions[0].id;
      }else{
        this.regionSelect = 0;
      }
      this.search();
      this.spinner.hide();
    }),
    (error: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  changeRegion(e){
    this.regionSelect = e.value;
  }

  setLS(){
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
    this.colorFont = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT);
    this.colorFont2 = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT2);
    //validate Permisses menu
    var menu = JSON.parse(localStorage.getItem(AppConstants.Session.MENU));
    var page = this.router.url.split("/");
    var i = page[page.length-1];
    var itemTag = menu.filter(x => x.tag != null && (x.tag.toString()).toLowerCase().includes(i));
    if(itemTag.length>0){
      this.enabledRead = itemTag[0].activeRead;
      this.enabledWrite = itemTag[0].activeWrite;
    }else{
      this.enabledRead = 0;
      this.enabledWrite = 0;
    }
  }

  getZonesByEnterprise() {
    this.enterprisesZones = [];
    this.spinner.show();
    this.zoneService.getListAll(this.enterpriseSelect,this.headquarterSelect).subscribe(response => {
      if(response.error == null){
        var zones = response.data.filter(_ => _.type == 1);
        this.enterprisesZones = zones;
        if(this.enterprisesZones.length>0){
          this.enterpriseZoneSelect = this.enterprisesZones[0]["id"];
        }else{
          this.AlertService.showMessage("No tiene zonas VA registradas, debes de crear una zona para usar este módulo", "", MessageSeverity.error);
        }
        this.changeZone(0);
      }else{
        this.enterprisesZones = [];
        this.cameras = [];
      }
      this.cameraList();
      this.spinner.hide();
    });
  }

  changeZone(e: any) {
    if(e != 0){
      this.enterpriseZoneSelect = e.id;
    }
    this.cameraList();
  }


   ngAfterContentChecked(): void {
        if (this.paginatorTop) {
          this.paginatorBottom.length = this.paginatorTop.length;
        }
    }

    handlePaginatorTop(e): void {
        const { pageSize, pageIndex } = e;
        this.paginatorTop.pageSize = pageSize
        this.paginatorTop.pageIndex = pageIndex;
        this.paginatorTop.page.emit(e);
    }

    handlePaginatorBottom(e): void {
        const { pageSize, pageIndex } = e;
        this.paginatorBottom.pageSize = pageSize
        this.paginatorBottom.length = this.paginatorTop.length;
        this.paginatorBottom.pageIndex = pageIndex;
      }

  checkError(){
    if(!this.alertError){
      this.alertError = 1;
    }else{
      this.alertError = 0;
    }
  }

  createForm() {
    this.reportForm = this.formBuilder.group({
        startDateReport: ['', [Validators.required]],
        endDateReport: ['', [Validators.required]],
        startTimeReport: ['', [Validators.required, Validators.pattern("^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$")]],
        endTimeReport: ['', [Validators.required, Validators.pattern("^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$")]],
        idCamera: ['', [Validators.required]],
        idRegion: ['', [Validators.required]],
    });
  }

  _keyUp(event: any) {
    let charCode = (event.which) ? event.which : event.keyCode;
      console.log(event.keyCode)
      if (charCode != 46 && charCode != 58 && charCode > 31
        && (charCode < 48 || charCode > 57)) {
        return false;
      }
  }

  get f() { return this.reportForm.controls; }

  cameraList() {
    this.cameras = [];
    var data = {
      idZone: this.enterpriseZoneSelect,
      idEnterprise: this.enterpriseSelect,
      idHeadquarter: this.headquarterSelect
    }
    this.CameraService.getCameraByZone(this.enterpriseZoneSelect).subscribe((response => {
      this.cameras = response;
      if(this.cameras.length>1){
        this.cameraSelect = 0;
      }else if(this.cameras.length!=0){
        this.cameraSelect = this.cameras[0].cameraId;
      }
      this.changeCamera(1);
      this.spinner.hide();
    }),
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      });
  }

  userList() {
    this.users = [];
    var filter = {
      idEnterprise: this.enterpriseSelect,
      idHeadquarter: this.headquarterSelect
    };
    this.userService.getUserEnterpriseHeadquarters(filter).subscribe((response) => {
      if(response.error == null){
        this.users = this.users.concat(response.data);
      }
      this.userSelect = 0;
    },
      (error: HttpErrorResponse) => {
        this.loading = false;
      });
  }

  changeCameras() {
    this.changeCamera(0);
  }

  changeCamera(id: number) {
    this.spinner.show();
    this.cameraAlert = [];
    this.alertSelect = 0;
    this.CameraService.GetAlertByCamera(this.cameraSelect,0).subscribe((response) => {
      this.cameraAlert = response;
      this.alertSelect = 0;
      this.spinner.hide();
    },
      (error: HttpErrorResponse) => {
        this.cameraAlert = []
      });
  }

  export() {
        /* table id is passed over here */
        let dataToExport = this.dataSource.filteredData
        .map(x => ({
          Camara: x.camera,
          Region: x.region,
          Estado: x.state,
          Turno: x.shift,
          NOperarios: x.userQty,
          Item: x.item,
          FechaInicio: x.startedAt,
          FechaFin:x.finishedAt,
          Tiempo:x.timer,
          Conteo: x.count
        }));

    ///const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
      const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet(dataToExport);

        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */
        var date = new Date();
        var ts = this.datePipe.transform(this.date, 'dd/MM/yyyy') + " " + this.timeI;
        var tf = this.datePipe.transform(this.dateF, 'dd/MM/yyyy') + " " + this.timeF;
        var downfileNameload = 'reporte_camara_conteo_'+ts+"-"+tf+'.xls';
        XLSX.writeFile(wb, downfileNameload);

  }

  setData(){
    let search = this.reportForm.value;
    try{
      this.dateIView = search.startDateReport;//this.datePipe.transform(search.startDateReport, 'dd/MM/yyyy');
      this.dateFView = search.endDateReport; //this.datePipe.transform(search.endDateReport, 'dd/MM/yyyy');
      // alert("try catch 2 - " + this.dateIView);
     // search.startDateReport = this.datePipe.transform(search.startDateReport, 'dd/MM/yyyy');
     // search.endDateReport = this.datePipe.transform(search.endDateReport, 'dd/MM/yyyy');
    }catch{
      this.dateIView = search.startDateReport;
      this.dateFView = search.endDateReport;

      search.startDateReport = search.startDateReport;
      search.endDateReport = search.endDateReport;
    }
  }

  setDatas(){
    let search = this.reportForm.value;

    this.dateIView = this.datePipe.transform(search.startDateReport, 'dd/MM/yyyy');
    this.dateFView = this.datePipe.transform(search.endDateReport, 'dd/MM/yyyy');

   // search.startDateReport = this.datePipe.transform(search.startDateReport, 'dd/MM/yyyy');
   // search.endDateReport = this.datePipe.transform(search.endDateReport, 'dd/MM/yyyy');

  }

  search() {
    this.spinner.show();
    this.dateIView = this.datePipe.transform(this.date, 'yyyy-MM-dd');
    this.dateFView = this.datePipe.transform(this.dateF, 'yyyy-MM-dd');
      var filterS = {
        idEnterprise: this.enterpriseSelect,
        idHeadquarter: this.headquarterSelect,
        dateI: this.dateIView,
        dateF: this.dateFView,
        timeI: this.timeI,
        timeF: this.timeF,
        idCamera: this.cameraSelect,
        idRegion: this.regionSelect
      };
      //filterS.dateI = this.datePipe.transform(filterS.dateI, 'dd/MM/yyyy');
      //filterS.dateF = this.datePipe.transform(filterS.dateF, 'dd/MM/yyyy');
      this.CameraService.reportCameraCounter(filterS).subscribe((response) => {
        if(response.data.length > 0){
          this.dataSource.data = response.data;
        }else{
          this.dataSource.data = response.data;
          this.AlertService.showMessage(
            AppConstants.TitleModal.WARNING_TITLE,
            AppConstants.MessageModal.DATA_NULL_SEARCH,
            MessageSeverity.error);
        }
        this.spinner.hide();
      },
        (error: HttpErrorResponse) => {
          this.spinner.hide();
        });
  }

  alerta(element) {
    let dialogRef = this.dialog.open(ImageModalComponent, {
      data: { image: element.image },
      width: '800px', hasBackdrop: true
    });
  }

}
